import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/layout/header/header.component';
import { SidebarComponent } from './components/layout/sidebar/sidebar.component';
import { MaterialModule } from './material.module';
import { RouterModule } from '@angular/router';
import { ToastComponent } from './components/toast/toast.component';
import { DashboardComponent } from './components/layout/dashboard/dashboard.component';
import { UserAuditComponent } from './components/layout/user-audit/user-audit.component';
import { FormsModule } from '@angular/forms';
import { TemplatesModule } from '../features/templates/templates.module';
import { SpinnerModule } from "./components/spinner/spinner.module";
import { StreamingMetricsComponent } from './components/layout/dashboard/streaming-metrics/streaming-metrics.component';

@NgModule({
  declarations: [HeaderComponent, SidebarComponent, ToastComponent, UserAuditComponent, DashboardComponent, StreamingMetricsComponent],
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule,
    FormsModule,
    TemplatesModule,
    SpinnerModule
],
  exports: [
    HeaderComponent,
    DashboardComponent,
    SidebarComponent,
    MaterialModule,
    TemplatesModule,
    ToastComponent
  ]
})
export class SharedModule { }
